import { Injectable } from '@angular/core';
import { DomainService } from '@engagement/core/domain/domain.service';
import { CngEngagementEffect } from '@engagement/core/store/engagement.effect';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, map, mergeMap, switchMap, withLatestFrom } from 'rxjs';

import { ProfileFacade, toActionError } from '@contact/upgrade';

import { DomainAction, DomainDispatcher } from './domain.dispatcher';

@Injectable()
export class DomainEffect extends CngEngagementEffect {
  /**
   * Initialize effect
   */
  readonly load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DomainAction.Load),
      switchMap(() =>
        this.domainService.loadDomains().pipe(
          withLatestFrom(this.profileFacade.domainId$),
          mergeMap(([domains, domainUuid]) => {
            if (domains.length > 0) {
              const mainDomain = domains.find(domain => domain.domainUuid === domainUuid);
              return [this.domainDispatcher.loadSuccess(mainDomain || domains[0])];
            }
            return EMPTY;
          }),
          toActionError(err => this.domainDispatcher.loadFail(err))
        )
      )
    )
  );

  /**
   * Initialize effect
   */
  readonly init$ = createEffect(() => this.onInitEffects$.pipe(map(() => this.domainDispatcher.load())));

  constructor(
    private readonly actions$: Actions,
    private readonly domainDispatcher: DomainDispatcher,
    private readonly domainService: DomainService,
    private readonly profileFacade: ProfileFacade
  ) {
    super();
  }
}
